import { useStudio } from '../../store/studio-store';

export function StoryboardPanel() {
  const project = useStudio((s) => s.project);
  const seekFrame = useStudio((s) => s.seekFrame);
  const selectNode = useStudio((s) => s.selectNode);

  if (!project) {
    return (
      <div className="panel">
        <div className="panel-header">
          <h2>Storyboard</h2>
        </div>
        <div className="panel-empty">Load a project to see its storyboard.</div>
      </div>
    );
  }

  return (
    <div className="panel">
      <div className="panel-header">
        <h2>Storyboard</h2>
      </div>

      {project.scenes.map((scene) => (
        <section key={scene.id} className="storyboard-scene">
          <div className="storyboard-scene-header">
            <span className="scene-id">{scene.id}</span>
            {scene.title && <span className="scene-title">{scene.title}</span>}
            <span className="scene-duration">{scene.duration.toFixed(1)}s</span>
          </div>
          <div className="storyboard-shots">
            {scene.shots.map((shot) => (
              <button
                key={shot.id}
                type="button"
                className="storyboard-card"
                onClick={() => {
                  selectNode(shot.id);
                  seekFrame(shot.start * project.format.fps);
                }}
              >
                <div className="storyboard-thumb">
                  <span className="thumb-icon">🎬</span>
                </div>
                <div className="storyboard-meta">
                  <span className="sb-id">{shot.id}</span>
                  <span className="sb-camera">{shot.camera?.movement ?? 'static'}</span>
                  <span className="sb-duration">{shot.duration.toFixed(1)}s</span>
                </div>
                {shot.emotion && <div className="sb-emotion">{shot.emotion}</div>}
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
